// ANCHOR Base
import { Block } from 'baseui/block';
import { Input } from 'baseui/input';
import { StyledLink } from 'baseui/link';
import { LabelSmall } from 'baseui/typography';

// ANCHOR Models
import {
  useFormSubmissionQuestionItemAnswer,
} from '@lyon/scoped-models/answer/FormSubmissionQuestionItem';

// ANCHOR Utils
import { parseFileFromUrl } from '@lyon/utils/extras/parseFileFromUrl';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { LyonViewAnswerFormQuestionStatusIcon } from '../../LyonViewAnswerFormQuestionStatusIcon';

// ANCHOR Constants
import { PLACEHOLDER } from './constants';

// ANCHOR Styles
import { BLOCK, INPUT } from './styles';

export const LyonViewAnswerFormAttachment = constant(() => {
  const userAnswers = useFormSubmissionQuestionItemAnswer();

  const file = userAnswers[0]?.replace('s1.streamvod.online', 's3.trylyon.com');
  const value = file && parseFileFromUrl(file).file.file;

  return (
    <Block marginBottom="24px">
      <Block overrides={BLOCK}>
        <Input
          value={value}
          placeholder={PLACEHOLDER}
          overrides={INPUT}
          size="default"
        />
        <LyonViewAnswerFormQuestionStatusIcon />
      </Block>
      {
        file && (
          <LabelSmall marginTop="16px">
            <StyledLink
              href={file}
              target="_blank"
              rel="noreferrer noopener"
            >
              Click to preview/download the attachment
            </StyledLink>
          </LabelSmall>
        )
      }
    </Block>
  );
});
